/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { globalContext } from 'contexts/globalContext';
import API from 'api';
import EmailField from 'components/pages/SignIn/Widgets/EmailField';
import PasswordField from 'components/pages/SignIn/Widgets/PasswordField';
import ConfirmPasswordField from 'components/pages/SignIn/Widgets/ConfirmPasswordField';
import PhoneNumberField from 'components/pages/SignIn/Widgets/PhoneNumberField';
import ActionButton from 'components/Common/ActionButton';
import HideableContainer from 'components/Common/HideableContainer';
import Steps from '../steps';
import Styles from './index.module.css';

export default function ResetPasswordForm({
  step,
  onChangeStep,
  resetPasswordEmail,
  onChangeResetPasswordEmail,
}) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { state, dispatch } = useContext(globalContext);
  const history = useHistory();

  const handleForgotPassword = async () => {
    const result = await API.auth.postForgotPassword(email, phone);
    if (result.error) {
      alert(result.error.errorMsg);
      return result.error;
    }
    onChangeResetPasswordEmail(email);
    onChangeStep(Steps.ResetPassword);
    return null;
  };

  const phoneValidation = (value) => value.replace(/\D/, '');

  const login = async (password) => {
    const result = await API.auth.postUserLogin(resetPasswordEmail, password, '');
    if (result.error) {
      if (result.error.errorMsg !== 'Auth Login User Exsisted But Not Verified') {
        alert('您的暫時密碼輸入錯誤，請至信箱複製正確的暫時密碼，謝謝');
        return result.error;
      }
      onChangeStep(Steps.ActivateAccount);
      return true;
    }
    localStorage.setItem('access_Token', `Bearer ${result.resultData.access_Token}`);
    localStorage.setItem('userId', result.resultData.id);
    localStorage.setItem('studio', `${result.resultData.iFrameCode}`);
    localStorage.setItem('amounts', JSON.stringify({ google: result.resultData.googleAmount, facebook: result.resultData.facebookAmount }));
    dispatch({ type: 'SET_AMOUNT', payload: { google: result.resultData.googleAmount, facebook: result.resultData.facebookAmount } });
    API.axiosInstance.defaults.headers.common.Authorization = localStorage.getItem('access_Token');
    return null;
  };

  const handleResetPassword = async () => {
    const failure = await login(oldPassword);
    if (failure) return failure;

    const result = await API.auth.postUpdateUserPassword(newPassword, oldPassword);
    if (result.error) {
      alert('您的暫時密碼輸入錯誤，請至信箱複製正確的暫時密碼，謝謝');
      return result.error;
    }
    alert('密碼重設成功');
    history.push({
      pathname: '/MyAds',
      state: {
        google: result.resultData.googleAmount,
        facebook: result.resultData.facebookAmount,
      },
    });
    return null;
  };

  const handleAction = () => {
    if (step === Steps.ForgotPassword) {
      handleForgotPassword();
    } else if (step === Steps.ResetPassword) {
      handleResetPassword();
    }
  };

  return (
    <form id="forgotPass" className={Styles.container} onSubmit={(e) => e.preventDefault()}>
      <div className={Styles.title}>
        {step === Steps.ForgotPassword && '忘記密碼'}
        {step === Steps.ResetPassword && '重設密碼'}
        {step === Steps.ResetPassword && (
        <div className={Styles.subtitle}>
          <span>系統已發送密碼重設信至您的註冊信箱，</span>
          <br />
          <span>請複製系統提供的暫時密碼，返回更新您的密碼</span>
        </div>
        )}
      </div>
      <HideableContainer hidden={step !== Steps.ForgotPassword}>
        <EmailField value={email} onChange={(e) => setEmail(e.target.value)} />
      </HideableContainer>
      <HideableContainer hidden={step !== Steps.ForgotPassword}>
        <PhoneNumberField value={phoneValidation(phone)} onChange={(e) => setPhone(e.target.value.replace(/\D/, ''))} />
      </HideableContainer>
      <HideableContainer hidden={step !== Steps.ResetPassword}>
        <PasswordField autoComplete="new-password" title="暫時密碼" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
      </HideableContainer>
      <HideableContainer hidden={step !== Steps.ResetPassword}>
        <PasswordField autoComplete="new-password" title="新密碼" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
      </HideableContainer>
      <HideableContainer hidden={step !== Steps.ResetPassword}>
        <ConfirmPasswordField
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </HideableContainer>
      <div className={Styles.resetButtonContainer}>
        <ActionButton style={{ width: '100%', maxWidth: 280, color: '#FFFFFF' }} onClick={handleAction}>
          {step === Steps.ForgotPassword && '傳送重設密碼連結'}
          {step === Steps.ResetPassword && '重設密碼'}
        </ActionButton>
      </div>
    </form>

  );
}

ResetPasswordForm.propTypes = {
  step: PropTypes.string,
  onChangeStep: PropTypes.func,
  resetPasswordEmail: PropTypes.string,
  onChangeResetPasswordEmail: PropTypes.func,
};

ResetPasswordForm.defaultProps = {
  step: '',
  onChangeStep: () => {},
  resetPasswordEmail: '',
  onChangeResetPasswordEmail: () => {},
};
